import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal } from 'antd'
import { filter, isEmpty, isNil, toString } from 'lodash'

import { showErrorNotification } from '../../../core/helpers'

import { useUpdateDishTypeByMenuTitleMutation } from '../../../dishes/hooks'
import { setMenuTitleForIgnoredDishType } from '../../redux/actions'
import {
  StyledIgnoredDishTypeModalContainer,
  StyledIgnoredDishTypeModalTreeSelect,
} from '../styled'

const MenuTitleIgnoredDishTypeModal = () => {
  const dispatch = useDispatch()

  const menuTitle = useSelector(
    store =>
      store.menuCurationTasks.menuCurationTask.menuTitleForIgnoredDishType,
  )

  const { dishTypeOptions } = useSelector(store => store.common.metadata.data)

  const [setIgnoredDishType, { isLoading, error }] =
    useUpdateDishTypeByMenuTitleMutation()

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Failed update dish types',
        description: error,
      })
    }
  }, [error])

  const ignoredDishTypeOptions = useMemo(() => {
    if (isEmpty(dishTypeOptions)) {
      return []
    }

    return filter(dishTypeOptions, 'isIgnored')
  }, [dishTypeOptions])

  const isRevertButtonDisabled = useMemo(
    () => isNil(menuTitle?.dishTypeId) || isLoading,
    [isLoading, menuTitle?.dishTypeId],
  )

  const handleCancel = useCallback(() => {
    dispatch(setMenuTitleForIgnoredDishType({ menuTitle: null }))
  }, [dispatch])

  const handleRevert = useCallback(() => {
    setIgnoredDishType(null, menuTitle.id)
    handleCancel()
  }, [handleCancel, menuTitle?.id, setIgnoredDishType])

  const handleChange = useCallback(
    dishTypeId => {
      setIgnoredDishType(dishTypeId, menuTitle.id)
      handleCancel()
    },
    [handleCancel, menuTitle?.id, setIgnoredDishType],
  )

  if (isNil(menuTitle)) {
    return null
  }

  return (
    <Modal
      title="Set ignored dish type"
      centered
      width={500}
      visible
      footer={null}
      onCancel={handleCancel}
    >
      <StyledIgnoredDishTypeModalContainer>
        <StyledIgnoredDishTypeModalTreeSelect
          showSearch
          placeholder="Select dish type"
          disabled={isLoading}
          defaultValue={toString(menuTitle.dishTypeId)}
          treeData={ignoredDishTypeOptions}
          dropdownStyle={{ maxHeight: 400, minWidth: 250 }}
          onChange={handleChange}
        />
        <Button onClick={handleRevert} disabled={isRevertButtonDisabled}>
          Revert
        </Button>
      </StyledIgnoredDishTypeModalContainer>
    </Modal>
  )
}

export default MenuTitleIgnoredDishTypeModal
